import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import TranslateCardItem from './TranslateCardItem'
import { getStaticImage } from 'utils/statics'
import AVProcessSelector from '../AVProcessSelector'
import { lang } from 'utils/helpers'

const TranslateCard = ({
  consoleId,
  automaticTranslateChecked,
  setAutomaticTranslateChecked,
  isMultiIntent,
  setIsMultiIntent,
  isGroupable,
  setIsGroupable,
  ambiguity,
  setAmbiguity,
  updateBotHeader,
  toggleTranslationConfigModal,
  toggleAmbiguityConfigModal,
  defaultProcessId,
  smartchatProcesses,
  isLoadingProcesses
}) => (
  <div className='translate-card'>
    <strong className='translate-card__title'>{lang('dashboard_options')}</strong>
    <TranslateCardItem
      icon={getStaticImage('/icons/orange-brand/translation.svg')}
      title={I18n.t('dashboard_automatic-translation')}
      tooltip={I18n.t('av_translations_config_tooltip')}
      value={automaticTranslateChecked}
      onChange={value => {
        updateBotHeader(consoleId, { automaticTranslation: value })
        setAutomaticTranslateChecked(value)
      }}
      onClickConfigButton={toggleTranslationConfigModal}
    />
    <TranslateCardItem
      icon={getStaticImage('/icons/orange-brand/unknown-message.svg')}
      title={I18n.t('dashboard_process-ambiguity')}
      tooltip={I18n.t('av_ambiguity_config_tooltip')}
      value={ambiguity}
      onChange={value => {
        updateBotHeader(consoleId, { ambiguity: value })
        setAmbiguity(value)
      }}
      onClickConfigButton={toggleAmbiguityConfigModal}
    />
    <TranslateCardItem
      icon={getStaticImage('/icons/orange-brand/multiple-messages.svg')}
      title={I18n.t('dashboard_multiple-message')}
      tooltip={I18n.t('av_multiIntent_config_tooltip')}
      value={isMultiIntent}
      onChange={value => {
        updateBotHeader(consoleId, { isMultiIntent: value })
        setIsMultiIntent(value)
      }}
    />
    {/*isMultiIntent && (
      <TranslateCardItem
        icon={getStaticImage('/icons/orange-brand/messages-grouped.svg')}
        title={I18n.t('consoleFaq_groupable_title')}
        tooltip={I18n.t('av_groupable_config_tooltip')}
        value={isGroupable}
        onChange={value => {
          updateBotHeader(consoleId, { isGroupable: value })
          setIsGroupable(value)
        }}
        className='translate-card-child'
      />
    )*/}
    {smartchatProcesses?.length ? (
      <AVProcessSelector
        currentProcessId={defaultProcessId}
        processes={smartchatProcesses}
        isLoading={isLoadingProcesses}
        onChange={({ id }) => updateBotHeader(consoleId, { defaultProcessId: id })}
      />
    ) : null}
  </div>
)

export default TranslateCard
